<template>
  <div class="common-box application">
    <el-table :data="messageData" class="table-single margin-t20">
      <el-table-column label="姓名" prop="adviserName"></el-table-column>
      <el-table-column label="所在地" prop="city"></el-table-column>
      <el-table-column label="电话" prop="phone"></el-table-column>
      <el-table-column label="合作日期" >
        <template slot-scope="scope">
          <span>{{$dayjs(scope.row.addedDate).format('YYYY.MM.DD')}}</span>
        </template>
      </el-table-column>
      <el-table-column label="邮箱" prop="phone"></el-table-column>
      <el-table-column label="原因" width="300" prop="phone"></el-table-column>
    </el-table>
    <div class="control-box">
      <button>修改</button>
      <button class="submit">提交</button>
      <button>放弃</button>
    </div>
  </div>
</template>

<script>
  import pdf from 'vue-pdf'
  export default {
    data(){
      return {
        messageData:[], //列表数据
        dialogTableVisible:false,//简历弹出框
        pdfUrl:'', //当前展示文件url
        pageTotalNum:'',
      }
    },
    mounted() {
      this.GetApplyList()
    },
    methods:{
      //操作
      messageOpt(num,data){
        console.log('操作信息',num,data)
        const vm = this
        vm.$http.post(vm.$apiPath.UpdataAdvisorCheck,{
          Managercode:vm.$commonJs.getCookie("code"),//管理员代码
          CheckType:data, //
          ID:num
        }).then(res=>{
          console.log('结果',res)
          if(res.data.code == 200){
            vm.$message.success('处理成功')
            vm.GetApplyList()
          }else{
            vm.$message.error(res.data.message)
          }
        })
      },
      //关闭
      close(){
        this.pdfUrl = ''
        this.pageTotalNum=''
      },
      //预览文件
      popUp(url){
        if(url == '')return this.$message.warning('暂无数据')
        this.pdfUrl = url
        let task = pdf.createLoadingTask(this.pdfUrl)
        task.promise.then(res=>{
          this.pageTotalNum = res.numPages
        })
        this.dialogTableVisible = true

        console.log('查看文件预览',url)
      },
      //管理列表
      GetApplyList(){
        let vm = this
        vm.$http.post(vm.$apiPath.getApplyList,{}).then(res=>{
          console.log('查看数据',res)
          if(res.data.code == 200){
            vm.messageData = res.data.dataList
          }
        })
      },
    },
  }
</script>

<style scoped lang="less">
  .application{
    .control-box{
      width: 100%;
      margin:25px 0;
      text-align: center;
      button{
        margin:0 15px;
        width:86px;
        height:32px;
        border: 1px solid @color;
        border-radius: 8px;
        background-color: @wColor;
        font-size: 14px;
        font-weight: bold;
        cursor: pointer;
        color:@color;
      }
      .submit{
        background-color: @color;
        color:@wColor;
      }
    }

    .btn-box{
      display: flex;
      justify-content: space-between;
      align-items: center;
      .select{
        cursor: pointer;
        font-size: 14px;
        font-weight: 500;
        color: @color0653A2;
        display: inline-block;
        padding:0 17px;
      }
      .line{
        width: 1px;
        height: 13px;
        border-right: 1px solid #BFBFBF;
      }

    }

    .open-title{
      color: @color2B448F;
      font-weight: bold;
      cursor: pointer;
    }
    .btn{
      width: 44px;
      height: 22px;
      border: 1px solid @color2B448F;
      border-radius: 4px;
      font-size: 14px;
      font-weight: 500;
      color: @color2B448F;
      display: inline-block
    }
    .btn-bg{
      background: @color2B448F;
      color: @wColor;
    }
  }
</style>
